<template>
  <div ref="resultView">
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer ">
      <div class="appraisal-center fonts marr" style="margin-top: 10px;width: 100%">
        <el-tabs class="on_tous_sdas" v-model="resultMode" @tab-click="handleTabClick">
          <el-tab-pane label="职业性格设置" name="jzjg"></el-tab-pane>
          <el-tab-pane label="职业性格详情设置" name="xgjg"></el-tab-pane>
        </el-tabs>
        <template v-if="resultMode=='jzjg'">
          <div>
            <span>维度：</span>
            <span>
            <el-tag
                :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                v-for="(item, index) in getWDData"
                :key="item.examDimensionId"
                @click="activeEvent(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
          </div>
          <div style="margin-top: 20px">
            <span>基准：</span>
            <span>
            <el-tag
                :class="{ 'tag-marr': true,'tag-marrs': true, 'active-bg1': tagJzIndex == index }"
                v-for="(item, index) in getJZData"
                :key="index"
                @click="activeEventJz(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
          </div>
          <div style="margin-top: 20px">
            <el-button type="success" size="small" @click="handleClick('add')"
            >添加结果<i class="el-icon-plus"></i
            ></el-button>
            <span class="subject"
            >共 <i>{{ tagIndex == 0 ? detalisObj.questions : emptyShow(getWDData[tagIndex]).questions }}</i> 题，<i>{{
                tagIndex == 0 ? detalisObj.maxScore : emptyShow(getWDData[tagIndex]).maxScore
              }}</i
            >分
          </span>
          </div>
          <div style="margin-top: 20px">
            <div class="public-table-data">
              <el-table
                  ref="multipleTable"
                  size="medium"
                  :data="getWdResulData"
                  border
                  style="width: 100%"
                  row-key="menuId"
                  v-loading="loading"
              >
                <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="minScore"
                    label="最小值"
                    width="80"
                    align="center"
                >
                </el-table-column>

                <el-table-column
                    prop="maxScore"
                    label="最大值"
                    width="80"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="标题"
                    width="100"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="状态"
                    width="100"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div class="content_div" v-html="scope.row.title"></div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="content"
                    label="说明"
                    min-width="220"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div class="content_div">{{ setHtmlData(scope.row.content) }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    min-width="180"
                >
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="handleClick('edit', scope.row)"
                        type="primary"
                        plain
                    >编辑
                    </el-button
                    >
                    <el-button
                        size="mini"
                        @click="handleDelete(scope.row)"
                        type="danger"
                        plain
                    >删除
                    </el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
        <template v-if="resultMode=='xgjg'">
          <div class="topic-outer" v-loading="loading" style="padding-bottom: 30px">
            <el-empty description="暂无数据" v-if="noContentJz"></el-empty>
            <div v-else class="appraisal-center fonts marr">
              <template v-if="initJZData">
                <el-tabs
                    tab-position="left"
                    v-model="activeName"
                    @tab-click="handleChangClick"
                >
                  <el-tab-pane
                      v-for="item in initJZData"
                      :key="item.examResultId"
                      :label="item.code"
                      :name="item.examResultId.toString()"
                  >
                  </el-tab-pane>
                  <div>
                    <div class="public-dialog-form">
                      <el-form
                          ref="ruleForm"
                          :rules="contentrules"
                          :model="contentParams"
                          label-width="110px"
                      >
                        <el-tabs type="card" v-model="languageCode" @tab-click="resultHandleTabClick">
                          <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                                      :key="index"></el-tab-pane>
                        </el-tabs>
                        <el-row>
                          <el-col :span="16">
                            <el-form-item label="人格类型名称" prop="title">
                              <el-input placeholder="请填写性格类型名称" v-model="contentParams.title"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="人格类型特性" prop="content">
                              <rich-text v-if="innerVisible" :keyWord="'content'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item> -->
                            <el-form-item label="人格类型描述" prop="descr">
                              <rich-text v-if="innerVisible" :keyWord="'descr'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="人格关键词" prop="keyword">
                              <rich-text v-if="innerVisible" :keyWord="'keyword'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="人群性格占比" prop="crowdRatio">
                              <el-input v-model="contentParams.crowdRatio" placeholder="人群占比/男性占比/女性占比"></el-input>
                            </el-form-item>
                            <el-form-item label="人格知名人物" prop="figureVos">
                              <!-- <rich-text v-if="innerVisible" :keyWord="'guideSuggest'"
                                         :params="contentParams?contentParams:''"></rich-text> -->
                              <div class="public-table-data">
                                <el-table
                                    ref="multipleTable"
                                    size="mini"
                                    :data="figureTableData"
                                    border
                                    style="width: 100%"
                                    row-key="menuId"
                                    v-loading="loading"
                                >
                                  <el-table-column type="index" label="排序" width="50" align="center">
                                  </el-table-column>
                                  <el-table-column prop="figureImage" label="人物头像" width="90" align="center">
                                    <template slot-scope="scope">
                                      <div  v-if="scope.row.figureImage">
                                        <img @click="getPolicyFigure(scope.$index)" style="width: 40px; height: 40px; border-radius: 6px" :src="scope.row.figureImage" />
                                      </div>
                                      <div v-else class="diplay" :class="{'active_display':scope.row.figureImage}">
                                        <div class="screenshot">
                                          <template v-if="scope.row.figureImage">
                                            <span
                                              v-for="(imgUrl, index) in srcListFigure"
                                              :key="index"
                                              class="slideshow"
                                            >
                                              <el-image
                                                  style="width: 40px; height: 40px; border-radius: 6px"
                                                  :src="imgUrl"
                                                  fit="cover"
                                                  @click="getPolicyFigure(scope.$index)"
                                              />
                                            </span>
                                          </template>

                                          <div
                                              class="up-btn"
                                              style="width: 40px; height: 40px; line-height: 45px"
                                              @click="getPolicyFigure(scope.$index)"
                                              v-if="isMoerFigure || !scope.row.figureImage"
                                          >
                                            <i class="el-icon-plus"></i>
                                          </div>
                                        </div>
                                        <input
                                            type="file"
                                            ref="fileFigure"
                                            @change="getFileFigure"
                                            accept="image/png,image/jpg"
                                        />
                                      </div>
                                    </template>
                                  </el-table-column>
                                  <el-table-column prop="figureName" label="人物姓名" width="120" align="center">
                                    <template slot-scope="scope">
                                      <el-input
                                          type="text"
                                          v-model="scope.row.figureName"
                                          size="mini"
                                      ></el-input>
                                    </template>
                                  </el-table-column>
                                  <el-table-column prop="figureDesc" label="人物说明" width="320" align="center">
                                    <template slot-scope="scope">
                                      <el-input
                                          type="text"
                                          v-model="scope.row.figureDesc"
                                          size="mini"
                                      ></el-input>
                                    </template>
                                  </el-table-column>
                                  <el-table-column label="操作" align="center" fixed="right">
                                    <template slot-scope="scope">
                                      <el-button
                                          size="mini"
                                          @click="handleFigureDelete(scope.row, scope.$index)"
                                          type="danger"
                                          plain
                                      >删除
                                      </el-button
                                      >
                                    </template>
                                  </el-table-column>
                                </el-table>
                                <el-button size="medium" type="success" @click="handleAddfigure">添加人物</el-button>
                              </div>
                            </el-form-item>
                            <el-form-item label="主导心理和辅助心理功能" prop="mentalDesc">
                              <rich-text v-if="innerVisible" :keyWord="'mentalDesc'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="人格阴影区" prop="growth">
                              <rich-text v-if="innerVisible" :keyWord="'growth'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="人格健康发展" prop="healthDevelop">
                              <rich-text v-if="innerVisible" :keyWord="'healthDevelop'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="人格与人际关系" prop="relationships">
                              <rich-text v-if="innerVisible" :keyWord="'relationships'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="人格与职业发展" prop="careerDevelopment">
                              <rich-text v-if="innerVisible" :keyWord="'careerDevelopment'"
                                         :params="contentParams?contentParams:''"></rich-text>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="性格类型图">
                              <div class="diplay" style="margin-right: 10px">
                                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 254px; height: 355px;border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                                  <div
                                      class="up-btn"
                                      style="width: 254px; height: 355px; line-height: 355px"
                                      @click="getPolicy"
                                      v-if="isMoer"
                                  >
                                    <i class="el-icon-plus"></i>
                                  </div>
                                </div>
                                <input
                                    type="file"
                                    ref="file"
                                    @change="getFile"
                                    accept="image/png,image/jpg"
                                />
                              </div>
                            </el-form-item>
                          </el-col>
                        </el-row>

                      </el-form>
                      <span slot="footer" class="public-dialog-footer">
                <el-button size="medium" @click="handleContentEdit('reset')">
                  重 置</el-button>
                <el-button
                    size="medium"
                    type="primary"
                    @click="handleContentEdit('add')"
                >提 交</el-button
                >
              </span>
                    </div>
                  </div>
                </el-tabs>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--结果设置-->
    <el-dialog
        title="结果设置"
        :visible.sync="dialogVisible"
        width="720px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            
            :model="params"
            label-width="80px"
        >
          <el-tabs type="card" v-model="languageCode" @tab-click="resultHandleTabClick2">
            <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                         :key="index"></el-tab-pane>
          </el-tabs>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="一级维度">
                <div>{{ resue.name }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if=" resue.name!='综合' && resueJz.name!='全部' ">
              <el-form-item label="二级基准">
                <div>{{ resueJz.name }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="最小值" prop="minScore">
                <el-input
                    placeholder="请输入最小值"
                    v-model="params.minScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大值" prop="maxScore">
                <el-input
                    placeholder="请输入最大值"
                    v-model="params.maxScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请输入名称"
                    v-model="params.name"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="标题" prop="title">
            <rich-text v-if="innerVisible" :keyWord="'title'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="关键词" prop="keyword">
            <rich-text v-if="innerVisible" :keyWord="'keyword'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="性格维度解析" prop="content">
            <rich-text v-if="innerVisible" :keyWord="'content'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="字母含义" prop="descr">
            <rich-text v-if="innerVisible" :keyWord="'descr'" :params="params?params:''"></rich-text>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import richText from "../../../components/richText";
import {isEmpty, emptyShow} from "@utils/tools/index";
import {ossUpload} from "@utils/filters/upload";
import Test from "../../WechatConfiguration/Test";

export default {
  components: {
    Test,
    richText,
  },
  data() {
    return {
      //之前的代码
      emptyShow, isEmpty,
      rules: {
        minScore: [
          {
            required: true,
            message: "请输入最小值",
            trigger: "blur",
          },
        ],
        maxScore: [
          {
            required: true,
            message: "请输入最大值",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        keyword: [
          {
            required: true,
            message: "请填写关键词",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写详解",
            trigger: "blur",
          },
        ],
        descr: [
          {
            required: true,
            message: "请填写字母含义",
            trigger: "blur",
          },
        ],


      },
      contentrules: {
        title: [
          {
            required: true,
            message: "请填写性格类型名称",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写性格类型详情",
            trigger: "blur",
          },
        ],
        descr: [
          {
            required: true,
            message: "请填写性格特征描述",
            trigger: "blur",
          },
        ],
        keyword: [
          {
            required: true,
            message: "请填写匹配的组织和岗位",
            trigger: "blur",
          },
        ],
        guideSuggest: [
          {
            required: true,
            message: "请填写职业推荐",
            trigger: "blur",
          },
        ],
        suggest2: [
          {
            required: true,
            message: "请填写职业建议",
            trigger: "blur",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      jzIsShow: true,
      jzIsHiden: false,
      initJZData: [],
      activeName: "",
      params: {},
      innerVisible: false,
      resultMode: 'jzjg',
      resueJz: {},
      getJZData: [],
      tagJzIndex: 0,
      getWDData: [], //维度列表
      getWdResulData: [], //维度结果列表
      tagIndex: 0,
      resue: {},
      noContentJz: false,
      dialogVisible: false,
      srcList: [],
      isMoer: true,
      shareSrcList: [],
      shareIsMoer: true,
      contentParams: {},
      currentExamResultId:'', //当前操作的结果对象ID
      languageCode: '',
      languageList: [],
      figureTableData:[],
      isMoerFigure: true,
      srcListFigure: [],
      changIndex:null
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs.ruleForm.resetFields();
        this.params = {}
        this.innerVisible = false
      }
    }
  },
  created() {
    this.getAppraisalData();
    this.getWDList()
    this.getLanguageList()
  },
  methods: {
    //获取语言列表
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/language/list`, {adminStatus: 1},
      );
      this.loading = false;
      this.languageList = res.data;
      this.languageCode = this.languageList[0].code
    },
     /**
     * 编辑题目时切换编辑语言
     */
     async resultHandleTabClick2(){
      const {data: resData} = await this.$get(
          `exam/result/info/${this.currentExamResultId}`,
          {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          }
      );
      if (resData.result != 200) return;
      let resObj = resData.data
      this.setParams(resObj)
      this.$nextTick(()=>{
        this.$refs.resultView.scrollTo(0,0)
      })
    },
    /**
     * 编辑结果时切换编辑语言
     */
    async resultHandleTabClick(){
      // Vue.set(this.params, 'keyword', null)
      // Vue.set(this.params, 'content', null)

      const {data: resData} = await this.$get(
          // `exam/result/info/${this.currentExamResultId}`,
          `exam/result/info/${this.activeName}`,
          {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          }
      );
      if (resData.result != 200) return;
      // this.params = resData.data;
      // this.contentParams = resData.data;
      let resObj = resData.data
      this.setParams(resObj)
      // if (resObj.figureVos) {
      //   for (let i = 0; i < resObj.figureVos.length; i++) {
      //     const el = resObj.figureVos[i];
      //     Vue.set(this.figureTableData, i, el)
      //   }
      // }
      this.$nextTick(()=>{
        this.$refs.resultView.scrollTo(0,0)
      })
    },
    //回填数据
    setParams(resObj){
      const {
        name,keyword, content, descr, title, crowdRatio, mentalDesc, growth, healthDevelop, relationships, careerDevelopment,figureVos
      } = resObj
      Vue.set(this.params,'name',name)
      Vue.set(this.params,'title',title)
      Vue.set(this.params,'keyword',keyword)
      Vue.set(this.params,'content',content)
      Vue.set(this.params,'descr',descr)
      Vue.set(this.contentParams,'title',title)
      Vue.set(this.contentParams,'keyword',keyword)
      Vue.set(this.contentParams,'crowdRatio',crowdRatio)
      Vue.set(this.contentParams,'descr',descr)
      Vue.set(this.contentParams,'mentalDesc',mentalDesc)
      Vue.set(this.contentParams,'growth',growth)
      Vue.set(this.contentParams,'healthDevelop',healthDevelop)
      Vue.set(this.contentParams,'relationships',relationships)
      Vue.set(this.contentParams,'careerDevelopment',careerDevelopment)
      console.log("figureVos",figureVos);
      this.figureTableData = figureVos || []
    },
    handleTabClick() {
      if (this.resultMode == 'jzjg') {
        this.getWDList()
      } else {
        this.initJZ()
      }
      this.srcList = []
      this.isMoer = true
      this.shareSrcList = []
      this.shareIsMoer = true
      this.params = {}
      this.contentParams = {}
      this.innerVisible = false
      this.languageCode = this.languageList[0].code
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        resData.data.map(item => {
          if (item.name != '综合') {
            this.getWDData.push(item)
          }
        })
      }
      /* tagIndex :激活的是哪个 维度  */
      if (this.getWDData.length != 0) {
        this.resue = {
          code: this.getWDData[this.tagIndex].code,
          name: this.getWDData[this.tagIndex].name,
        };
        this.getJZList(this.getWDData[this.tagIndex].code)
      } else {
        this.tableData = [];
        return
      }
    },
    /**
     * 获取基准列表
     */
    async getJZList(code) {
      this.getJZData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/datum/list`, {
        params: {
          examId: this.$route.query.examId,
          examDimensionCode: code,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data)
        this.getJZData = resData.data;
      /* tagJzIndex :激活的是哪个 基准  */
      if (this.getJZData.length != 0) {
        this.resueJz = {
          code: this.getJZData[this.tagJzIndex].code,
          name: this.getJZData[this.tagJzIndex].name,
        };
        this.getWdResultList(this.resue.code, this.resueJz.code);
      }
    },
    /**
     * 获取测评维度结果列表
     */
    async getWdResultList(examDimensionCode, examDatumCode) {
      this.loading = true;
      let temp = {examId: this.$route.query.examId,}
      if (emptyShow(examDimensionCode)) {
        temp.examDimensionCode = examDimensionCode
      }
      if (emptyShow(examDatumCode)) {
        temp.examDatumCode = examDatumCode
      }
      const {data: resData} = await this.$get(`exam/result/list`, {
        params: temp,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.getWdResulData = resData.data;
      } else {
        this.getWdResulData = [];
      }
      // if (emptyShow(resData.data)) {
      //   this.getWdResulData = resData.data;
      // } else {
      //   this.getWdResulData = [];
      // }
    },
    /**
     * 点击维度
     */
    activeEvent(index, code, name) {
      this.params = {}
      this.innerVisible = false
      this.tagIndex = index;
      this.params.examDimensionCode = code;
      this.getJZList(code)
      this.resue = {
        name,
        code,
      };
      if (name == '综合') {
        this.getWdResultList()
      }
    },
    /**
     * 点击基准
     */
    activeEventJz(index, code, name) {
      this.tagJzIndex = index;
      this.resueJz = {
        name,
        code,
      };
      this.params = {}
      this.innerVisible = false
      if (this.resue == "ZHWD_370") {
        this.getWdResultList();
      } else {
        this.getWdResultList(this.resue.code, code);
      }
    },

    async handleClick(type, row = {}) {
      this.clickType = type;
      this.params = {};
      this.dialogVisible = true;
      this.innerVisible = false
      this.languageCode = this.languageList[0].code
      if (type == "add") {
        this.params = {};
        this.innerVisible = true
      }
      if (type == "edit") {
        const {data: resData} = await this.$get(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        this.innerVisible = true
        this.currentExamResultId = row.examResultId
        let resObj = resData.data
        if (resObj.figureVos) {
          for (let i = 0; i < resObj.figureVos.length; i++) {
            const el = resObj.figureVos[i];
            Vue.set(this.figureTableData, i, el)
          }
        }
      }
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      if (parseInt(this.params.minScore) > parseInt(this.params.maxScore)) {
        this.$message.error('最小值不能大于最大值')
        return
      }
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if (this.clickType == "add") {
          this.params.examDimensionCode = this.resue.code;
          this.params.examDatumCode = this.resueJz.code;
          this.params.examId = this.$route.query.examId;
          const {data: resData} = await this.$post(
              "exam/result/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                  'Language-Code': this.languageCode
                },
              }
          );
          if (resData.result != 200) return;
          this.getWdResultList(this.resue.code, this.resueJz.code);
          this.dialogVisible = false;
          this.$message.success("添加成功!");
          this.params = {};
        } else {
          const {data: resData} = await this.$put(
              "exam/result/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                  'Language-Code': this.languageCode
                },
              }
          );
          if (resData.result != 200) return;
          this.getWdResultList(this.resue.code, this.resueJz.code);
          this.dialogVisible = false;
          this.$message.success("修改成功!");
        }
      });
      // this.$refs.ruleForm.validate((valid) => {
      //   if (!valid) return;
        
      // });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.getWdResultList(this.resue.code);
      });
    },
    //过滤标签数据
    setHtmlData(str) {
      let obj = ''
      if (str) {
        obj = str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '')
      }
      return obj
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 初始化基准
     */
    async initJZ() {
      this.loading = true;
      const {data: resData} = await this.$post(
          `exam/result/init/datum/${this.$route.query.examId}`
      );

      if (resData.result != 200) {
        this.loading = false;
        return;
      } else {
        this.loading = false;
        if (resData.data) {
          this.noContentJz = false
          this.jzIsShow = false;
          this.jzIsHiden = true;
          resData.data.map(item => {
            item.examResultContent = item.code
          })
          this.initJZData = resData.data;
          let id = resData.data[0].examResultId;
          this.activeName = id.toString();
          this.params.examResultId = id;
          this.resultDetails(id);
          this.currentExamResultId = id
        } else {
          this.noContentJz = true
          this.initJZData = []
        }
      }
    },

    async resultDetails(examResultId) {
      const {data: resData} = await this.$get(
          `exam/result/info/${examResultId}`,
          {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          }
      );
      if (resData.result != 200) return;
      this.srcList = []
      this.isMoer = true
      if (resData.data) {
        if (resData.data.icon) {
          this.srcList.push(resData.data.icon)
          this.isMoer = false
        }
        this.contentParams = resData.data;
        this.innerVisible = true
      } else {
        this.contentParams = {}
        this.innerVisible = true
      }
      let resObj = resData.data
      this.setParams(resObj)
      // if (resObj.figureVos) {
      //   for (let i = 0; i < resObj.figureVos.length; i++) {
      //     const el = resObj.figureVos[i];
      //     Vue.set(this.figureTableData, i, el)
      //   }
      // }
    },

    handleContentEdit(type) {
      if (type == "add") {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            Object.assign(this.contentParams, { figureVos : this.figureTableData})
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.contentParams,
                {
                  headers: {
                    isLoading: true,
                    'Language-Code': this.languageCode
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
          })
        });
      } else if (type == "reset") {
        this.$confirm("确认重置当前数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "exam/result/init/datum/" + this.$route.query.examId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$refs.ruleForm.resetFields();
          this.contentrules = {}
          this.$message.success("重置成功!");
        })
      }
    },

    handleChangClick(tab, event) {
      this.innerVisible = false
      this.srcList = []
      this.isMoer = true
      this.shareSrcList = []
      this.shareIsMoer = true
      this.$refs.ruleForm.resetFields();
      this.contentParams = {}
      this.contentParams.examResultId = parseInt(tab.name);
      this.languageCode = this.languageList[0].code
      this.resultDetails(tab.name);
    },
    //添加人格对应人物
    handleAddfigure(){
      this.isMoerFigure = true
      this.srcListFigure = []
      // 向表格数组中数据添加一行
      this.figureTableData.push({
        figureName: "",
        figureDesc: "",
        figureImage: "",
      });
    },
    //删除人物
    handleFigureDelete(row, index){
      this.figureTableData.splice(index,1)
    },

    goBack() {
      this.$router.go(-1);
    },

    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.contentParams.icon = this.srcList[0];
    },

    getPolicyFigure(e) {
      this.$refs.fileFigure.dispatchEvent(new MouseEvent("click"));
      this.changIndex = e
    },
    async getFileFigure() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileFigure.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListFigure
      );
      this.isMoerFigure = false;
      this.srcListFigure = addRoutes;
      this.figureTableData[this.changIndex].figureImage = this.srcListFigure[0];
      this.changIndex = null

    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}

.initialize {
  margin-top: 20px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 100%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  //margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.tag-marrs {
  border-color: #fbc4c4;
  color: #f56c6c;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

</style>
<style>
.topic-outer .el-tabs__item {
  white-space: pre-wrap;
  text-align: center !important;
  /*line-height: 20px;*/
  /*height: 46px !important;*/

}

.topic-outer .el-form-item {
  margin-bottom: 20px;
}

.topic-outer .ql-container.ql-snow {
  height: 260px;
}

.topic-outer .quill-editor.editor {
  margin-bottom: 0;
}

.on_tous_sdas .el-tabs__nav-wrap {
  width: 300px !important;
}

.on_tous_sdas .el-tabs__nav {
  width: 100% !important;
}

.on_tous_sdas .el-tabs__item {
  width: 50%;
  padding: 0 !important;
  text-align: center;
  line-height: 46px !important;
  font-weight: 600;
}

.on_tous_sdas .el-tabs__active-bar {
  height: 1px !important;
}

.on_tous_sdas .el-tabs__nav-wrap::after {
  height: 1px !important;
}


</style>
